<template>
  <Section
    :id="id"
    :header="t('cargoInsurance.cargoInsurance')"
    :loading="cargoInsuranceCertificate.loading"
    class="shipment-cargo-insurance-certificate-section"
  >
    <template #headerRight>
      <CargoInsuranceActionButton
        :cargo-insurance-certificate="cargoInsuranceCertificate"
        @command="emit('command', $event)"
      />
    </template>

    <Card>
      <template #content>
        <CargoInsuranceCertificateDetail
          v-if="cargoInsuranceCertificate.data"
          :cargo-insurance-certificate="cargoInsuranceCertificate.data"
        />
        <PurchaseCargoInsuranceLoadingSkeleton
          v-if="cargoInsuranceCertificate.loading"
        />
      </template>
    </Card>
  </Section>
</template>

<script lang="ts" setup>
import { toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import { ActionCommand, Loadable } from '@rygen/rygen-ui/model';

import { CargoInsuranceCertificate, ShipmentAction } from '@/model';

import CargoInsuranceActionButton from '@/components/cargoInsurance/CargoInsuranceActionButton.vue';
import CargoInsuranceCertificateDetail from '@/components/cargoInsurance/CargoInsuranceCertificateDetail.vue';
import PurchaseCargoInsuranceLoadingSkeleton from '@/components/cargoInsurance/PurchaseCargoInsuranceLoadingSkeleton.vue';
import Section from '@rygen/rygen-ui/components/ui/Section.vue';
import Card from 'primevue/card';

const props = defineProps<{
  id: string;
  cargoInsuranceCertificate: Loadable<CargoInsuranceCertificate>;
}>();

const { id, cargoInsuranceCertificate } = toRefs(props);

const emit = defineEmits<{
  (event: 'command', payload: ActionCommand<ShipmentAction>): void;
}>();

const { t } = useI18n();
</script>
